import { Button, Flex, Heading, Stack, Box, Text } from "@chakra-ui/react"
import { ReactElement, ReactNode } from "react"
import { getGenericStatus, getGenericStatusBackgroundColor, getGenericStatusColor } from "../../utils";

interface SectionProps {
    sectionTitle: string;
    onClickEditButton: () => void;
    onClickConfirmButton: () => void;
    isEdit?: boolean;
    children?: ReactNode;
    buttons?: ReactElement[];
    statusSection?: string;
    isEditButtonHidden?: boolean;
}
export const Section = ({ children , buttons, sectionTitle, isEdit, onClickEditButton, onClickConfirmButton, statusSection, isEditButtonHidden = false}: SectionProps) => {
    function handleClickButton() {
        if (!isEdit) return onClickEditButton();
        onClickConfirmButton();
    }
    return(
        <Stack
            w="100%" 
            borderBottom="1px solid #DFE3EC"
            py="1.5rem"
            as="form"
        >
            <Flex align="center" justify="space-between">
                <Flex
                    align="center"
                    gap="8px"
                >
                    <Heading fontSize={["18px", "20px"]} fontWeight="600">{sectionTitle}</Heading>

                    {statusSection && (
                        <Text
                            p="0 4px"
                            backgroundColor={getGenericStatusBackgroundColor(statusSection)}
                            color={getGenericStatusColor(statusSection)}
                        >
                        {getGenericStatus(statusSection)}
                      </Text>
                    )}
                </Flex>
                <Flex gap={2}>
                    {buttons?.map((button, index) => ( 
                        <Box key={index}>
                            {button}
                        </Box>
                    ))}
                    {(sectionTitle !== "Acesso" && sectionTitle !== "Conta Swap") && !isEditButtonHidden && (
                        <Button
                            variant={isEdit ? "primary" : ""}
                            borderRadius="2px"
                            border={isEdit ? "" : "1px solid #D9D9D9"}
                            bgColor={isEdit ? "" : "white"}
                            p="0 0.5rem"
                            fontSize="14px"
                            onClick={handleClickButton}
                        >
                            {isEdit ? "Pronto" : "Editar"}
                        </Button>
                    )}
                </Flex>
            </Flex>
            {children}
        </Stack>
    )
}